var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import { jsx } from 'theme-ui';
import sizes from './sizes';
/**
 * A download icon.
 * @param {object} props
 * @param {string} [props.className]
 * @param {string} [props.size] The icon size.
 */
export default function MessageIcon(_a) {
    var { className, size = 'small' } = _a, rest = __rest(_a, ["className", "size"]);
    return (jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", sx: { width: sizes[size], height: sizes[size], verticalAlign: 'middle' }, className: className, viewBox: "0 0 20 12" }, rest),
        jsx("g", { fill: "none", fillRule: "evenodd", stroke: "none", strokeWidth: "1" },
            jsx("g", { fill: "currentColor", transform: "translate(-293 -1239)" },
                jsx("g", { transform: "translate(253 1115)" },
                    jsx("g", { transform: "translate(40 120)" },
                        jsx("path", { d: "M1 15V5.551l8.56 6.247a.752.752 0 00.882-.001L19 5.552V15H1zM18.059 5L10 10.881 1.941 5h16.118zm1.191-1H.75a.75.75 0 00-.75.75v10.5c0 .413.337.75.75.75h18.5c.413 0 .75-.337.75-.75V4.75a.75.75 0 00-.75-.75z" })))))));
}
//# sourceMappingURL=MessageIcon.js.map